import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import ScrollToTop from "../Components/ScrollToTop";
import MainNavbar from "../Components/Navbar/MainNavbar";

const RootLayout = () => {
  return (
    <>
      <ScrollToTop />
      <MainNavbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default RootLayout;
